import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const PageHero = ({ image, eyebrow, title, copy, height = "h-[72vh] min-h-[580px]" }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [0, 110]);

  return (
    <section ref={ref} className={`relative overflow-hidden ${height}`}>
      <motion.img src={image} alt="" style={{ y }} className="absolute -top-16 h-[calc(100%+128px)] w-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#14274A]/45 via-[#14274A]/40 to-[#14274A]/85" />
      <div className="absolute inset-0 hero-grain" />
      <div className="relative z-[1] flex h-full items-center justify-center px-6 pt-20 text-center text-white">
        <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: .9, ease: [0.16, 1, 0.3, 1] }} className="max-w-3xl">
          <p className="section-eyebrow !text-[#E0B973]">{eyebrow}</p>
          <h1 className="font-garamond text-6xl font-medium leading-[.9] sm:text-7xl lg:text-8xl">{title}</h1>
          {copy && <p className="mx-auto mt-6 max-w-xl font-montserrat text-sm font-light leading-7 text-white/80 sm:text-base">{copy}</p>}
        </motion.div>
      </div>
    </section>
  );
};

export default PageHero;
